import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import './scss/login.scss';
import Buttons from './../../components/buttons/buttons';
import { Grid } from '@material-ui/core';
import Input from './../../components/inputs/input-simple';
import { login, forgetPassword } from './../../actions/user-management.action';
import { closeSnackbar, errorSnackBar } from './../../actions/common.action';
import ForgotPassword from './forgot-password';
import { emailValidator } from '../../util/validators/email';
import { DASHBOARD, GLOBAL_ACCOUNT } from '../../constants/route-paths';
import { getSmartNavigationPath } from '../../util/smartNavigation';
import idx from 'idx';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  useEffect(() => {
    if (document) document.title = 'Contractable';
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setEmailTouched(true);
    setPasswordTouched(true);
    setEmailError(false);
    setPasswordError(false);
    let valid = true;

    const emailStatus = emailValidator(email);
    const isEmailEmpty = email.trim() === '';
    const isPasswordEmpty = password.trim() === '';

    if (isEmailEmpty && isPasswordEmpty) {
      valid = false;
      setEmailError("Please enter valid username");
      setPasswordError("Please enter valid password");
      dispatch(errorSnackBar("Please enter valid username and Password"));
    } else if (!emailStatus) {
      valid = false;
      setEmailError("Please enter valid username");
      dispatch(errorSnackBar("Please enter valid username"));
    } else if (isPasswordEmpty) {
      valid = false;
      setPasswordError("Please enter valid password");
      dispatch(errorSnackBar("Please enter valid password"));
    }

    if (valid) {
      dispatch(closeSnackbar());
      try {
        const response = await dispatch(login({ email, password }));
        if (!idx(response, _ => _.isLoggedIn)) navigate('/');
        if (response) redirectToDashboard(response);
      } catch (error) {
        console.error('Login failed:', error);
      }
    }
  };

  const redirectToDashboard = (data) => {
    if (location.pathname === '/login' || location.pathname === '' || location.pathname === '/') {
      if (idx(data, _ => _.is_global) === 1) navigate(`/${GLOBAL_ACCOUNT}`);
      else {
        // Get smart navigation path based on user permissions
        const smartPath = getSmartNavigationPath(data);
        if (smartPath) navigate(smartPath);
        else navigate(`/${DASHBOARD}`); // Fallback to dashboard if smart navigation fails
      }
    }
  }

  const forgotPassword = async (emailToReset) => {
    try {
      await dispatch(forgetPassword(emailToReset));
      handleDialog();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDialog = () => {
    setShowDialog(prevShowDialog => !prevShowDialog);
  };

  return (
    <div className='login'>
      {showDialog && (
        <ForgotPassword handleDialog={handleDialog} forgotPassword={forgotPassword} />
      )}
      <div className="login-form-begetter">
        <div className="login-form-abs-content">
          <div className="login-form-abs-content-img">
            <img src={require('./../../assets/logo.svg').default} alt='Logo' />
          </div>
          <p className='LoginHeading'>Login</p>
        </div>
        <div className='loginForm'>
          <div className='loginFormStart'>
            <form onSubmit={handleLogin}>
              <Grid xs={12} item>
                <div className="email-sec">
                  <div className="field-img-sec">
                    <img src={require('./../../assets/mail.png')} alt='mail' />
                  </div>
                  <Input
                    id='email'
                    grid={12}
                    type='email'
                    label='Email'
                    value={email}
                    data-cy="input-email"
                    valid={!emailError}
                    error={emailError}
                    touched={emailTouched}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setEmailError(false);
                    }}
                    onFocus={() => setEmailTouched(true)}
                  />
                </div>
                <div className="email-sec password-sec">
                  <div className="field-img-sec">
                    <img src={require('./../../assets/password.png')} alt='password' />
                  </div>
                  <Input
                    id='password'
                    type='password'
                    label='Password'
                    value={password}
                    data-cy="input-password"
                    valid={!passwordError}
                    error={passwordError}
                    touched={passwordTouched}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError(false);
                    }}
                    onFocus={() => setPasswordTouched(true)}
                  />
                </div>
                <div className='ForgotDiv'>
                  <p onClick={handleDialog}>Forgot Password?</p>
                </div>
                <Buttons id="login-button" className='loginButton login-pg' type='submit' title='LETS GO' color='secondary' data-cy="login-button" />
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;